import React from 'react';
import { IconProps } from './types';

export const ArrowIcon = ({ className, title }: IconProps) => {
  return (
    <svg
      id="Laag_2"
      data-name="Laag 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      className={className}
    >
      <title>{title}</title>
      <path d="M18.7,1.78a2,2,0,1,0-3.17,2.44L22.28,13H3.34a2,2,0,0,0,0,4h19l-6.71,8.79a2,2,0,0,0,.38,2.8,2,2,0,0,0,2.8-.38L28.86,15Z" />
    </svg>
  );
};
